import React, { useState, useEffect } from 'react';
import PageHeader from "../../../components/layout/PageHeader.jsx";
import { useFirestoreGeneralOrderBy, useFirestore, useFirestoreGeneral } from '../../../firebase/useFirestore';
import Location from "../../../hooks/Location";
import { db } from '../../../firebase/config';
import { v4 as uuid } from 'uuid';
import { client } from "../../../hooks/Client";
import { useHistory } from "react-router-dom";
import firebase from '../../../firebase/compat';
import useSettings from "../../../hooks/Settings";
import timestampToDateInput from "../../../utils/timestampToDateInput";

const EditEvent = () => {
  // Local state
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [date, setDate] = useState('');
  const [outputsArray, setOutputsArray] = useState([]);
  const [personasArray, setPersonasArray] = useState([]);

  // Settings for persona display
  const { personasOn } = useSettings();

  // Routing and parameters
  const eventId = Location()[3];
  const history = useHistory();

  // Firestore hooks
  const events = useFirestoreGeneral('Events', 'ID', eventId || '');
  const outputs = useFirestoreGeneralOrderBy('Outputs', 'ActivityID', events[0]?.ActivityID || '', 'Position', 'asc');
  const personas = useFirestore('Personas');

  // Initialize form values from fetched event
  useEffect(() => {
    if (events && events.length > 0) {
      const evt = events[0];
      setTitle(evt.Title || '');
      setDescription(evt.Description || '');
      setDate(timestampToDateInput(evt.Date));
      setOutputsArray(Array.isArray(evt.Outputs) ? evt.Outputs : []);
      setPersonasArray(Array.isArray(evt.Personas) ? evt.Personas : []);
    }
  }, [events]);

  // Handlers for local state updates
  const numberHandler = (e) => {
    const id = e.target.dataset.id;
    const value = e.target.value;
    setOutputsArray(prev => {
      const exists = prev.some(o => o.id === id);
      if (exists) {
        return prev.map(o => o.id === id ? { id, value } : o);
      } else {
        return [...prev, { id, value }];
      }
    });
  };

  const personaHandler = (e) => {
    const id = e.target.value;
    if (e.target.checked) {
      setPersonasArray(prev => [...prev, id]);
    } else {
      setPersonasArray(prev => prev.filter(p => p !== id));
    }
  };

  // Save all changes
  const saveEvent = async () => {
    if (!events || events.length === 0) return;
    const evt = events[0];
    const docRef = db.collection('Events').doc(evt.docid);
    const eventTimestamp = firebase.firestore.Timestamp.fromDate(new Date(date));

    try {
      // Update event document
      await docRef.update({
        Title: title,
        Description: description,
        Date: eventTimestamp,
        Outputs: outputsArray,
        Personas: personasArray,
      });

      // Remove old results
      const oldResultsSnap = await db.collection('Results')
        .where('CompagnyID', '==', client)
        .where('EventID', '==', eventId)
        .get();
      const batch = db.batch();
      oldResultsSnap.forEach(doc => batch.delete(doc.ref));
      await batch.commit();

      // Save new results
      const resultPromises = outputsArray.map(output => {
        return db.collection('Results').doc().set({
          Compagny: client,
          CompagnyID: client,
          ID: uuid(),
          Result: Number(output.value),
          Timestamp: eventTimestamp,
          OutputID: output.id,
          ActivityID: evt.ActivityID,
          Personas: personasArray,
          EventID: eventId,
        });
      });
      await Promise.all(resultPromises);

      history.push(`/${client}/outputresults`);
    } catch (error) {
      console.error('Error updating event or results:', error);
    }
  };

  return (
    <div className="main">
      <div className="main-container">
        <PageHeader
          heading="Gebeurtenis aanpassen"
          subHeading={title}
          description={`Pas hier de gebeurtenis '${title}' aan.`}
          AI={false}
        />
        {events && events.length > 0 && (
          <div id="edit-event-container">

            {/* Title */}
            <div className="table-container dashboard-container">
              <h2>Titel</h2>
              <input
                type="text"
                value={title}
                onChange={e => setTitle(e.target.value)}
                placeholder="Schrijf hier de titel van de gebeurtenis"
              />
            </div>

            {/* Date */}
            <div className="table-container dashboard-container">
              <h2>Datum</h2>
              <input
                type="date"
                value={date}
                onChange={e => setDate(e.target.value)}
              />
            </div>

            {/* Description */}
            <div className="table-container dashboard-container">
              <h2>Beschrijving</h2>
              <textarea
                value={description}
                placeholder="Schrijf hier de beschrijving van de gebeurtenis"
                onChange={e => setDescription(e.target.value)}
              />
            </div>

            {/* Outputs */}
            <div className="table-container dashboard-container">
              <h2>Outputs</h2>
              {outputs && outputs.map(output => {
                const current = outputsArray.find(o => o.id === output.ID);
                return (
                  <div key={output.ID} id="add-event-output-item-container">
                    <p>{output.Title}</p>
                    <input
                      type="number"
                      placeholder="0"
                      data-id={output.ID}
                      value={current?.value || ''}
                      onChange={numberHandler}
                    />
                  </div>
                );
              })}
            </div>

            {/* Personas */}
            <div
              className="table-container dashboard-container add-event-connect-persona-container"
              style={{ display: personasOn }}
            >
              <h2>Deelnemers</h2>
              {personas && personas.map(p => (
                <div key={p.ID} id="add-event-persona-item-container">
                  <input
                    type="checkbox"
                    value={p.ID}
                    checked={personasArray.includes(p.ID)}
                    onChange={personaHandler}
                  />
                  <label>{p.Name}</label>
                </div>
              ))}
            </div>

            {/* Save Button */}
            <div className="button-container">
              <button
                className="button"
                onClick={saveEvent}
              >
                Opslaan
              </button>
            </div>

          </div>
        )}
      </div>
    </div>
  );
};

export default EditEvent;

